import { apiV2 } from 'lib/api/v2'
import useSwr from 'swr'

type UsePartnersResponse = PartnersResponse['partners']

type PartnersResponse = {
  partners: Model.Partner[]
}

async function fetcher(): Promise<UsePartnersResponse> {
  const { data } = await apiV2.get<PartnersResponse>(`private/partners`)

  return data.partners
}

export function usePartners() {
  return useSwr('getPartners', fetcher, {
    revalidateOnFocus: false
  })
}
